import React from "react";
import { motion } from "framer-motion";
import { CheckCheck } from "lucide-react";
import { SectionHeading } from "@/components/effects/Reveal";
import { ParticleField } from "@/components/effects/ParticleField";
import { useLanguage } from "@/i18n/LanguageContext";
import { ASSETS } from "@/data/assets";

const ease = [0.22, 1, 0.36, 1];

// Erkek avatar görselleri: Lukas Brandt (0) ve Tunç Söğütlü (3)
const maleAvatars = [ASSETS.avatars[0], ASSETS.avatars[3]];

export const Quotes = () => {
  const { t } = useLanguage();
  const items = t.quotes.items;

  return (
    <section id="advertising" className="relative overflow-hidden py-24 sm:py-32">
      <ParticleField count={34} />
      <div className="absolute left-1/2 top-1/3 h-[28rem] w-[28rem] -translate-x-1/2 rounded-full bg-primary/10 blur-[150px]" />

      <div className="relative mx-auto max-w-5xl px-6">
        <SectionHeading tag={t.quotes.tag} title={t.quotes.title} subtitle={t.quotes.subtitle} />

        <div className="mt-16 flex flex-col gap-5 sm:gap-7">
          {items.map((q, i) => {
            const right = i % 2 === 1;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 28, x: right ? 28 : -28 }}
                whileInView={{ opacity: 1, y: 0, x: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: (i % 2) * 0.05, ease }}
                className={`flex w-full ${right ? "justify-end" : "justify-start"}`}
              >
                <motion.div
                  whileHover={{ y: -4 }}
                  transition={{ type: "spring", stiffness: 250, damping: 18 }}
                  className={`glass-strong relative flex max-w-xl items-start gap-4 rounded-[1.75rem] p-5 pr-6 shadow-card sm:gap-5 ${
                    right ? "lg:mr-8" : "lg:ml-8"
                  }`}
                >
                  {/* author avatar */}
                  <img
                    src={maleAvatars[i % 2]}
                    alt={q.author}
                    className="h-12 w-12 shrink-0 rounded-full border border-primary/30 object-cover shadow-glow-soft"
                  />

                  <div className="min-w-0 flex-1">
                    <p className="font-display text-lg font-semibold text-foreground">{q.author}</p>
                    <p className="mt-1 text-sm leading-relaxed text-muted-foreground sm:text-base">
                      “{q.text}”
                    </p>
                  </div>

                  {/* read receipt */}
                  <span className="mt-1 flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-primary/30 bg-primary/10 text-primary">
                    <CheckCheck className="h-4 w-4" />
                  </span>
                </motion.div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
